import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { ATO_STATES } from '../constants'

import {
  changeAtoAssigneesError,
  changeAtoAssigneesSuccess,
  changeIncidentStateError,
  changeIncidentStateSuccess,
} from './actions'
import { CHANGE_ASSIGNEES_ASYNC, CHANGE_INCIDENT_STATE_REQUEST_ASYNC } from './constants'

const changeIncidentStateEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(CHANGE_INCIDENT_STATE_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .changeAtoIncidentState(
        action.payload.incidentId,
        action.payload.newState,
        action.payload.newState === ATO_STATES.COMPROMISED &&
          Object.keys(store.getState().resolutioncenter.atoIncidentHeader.remediationActions)
            .filter(
              (e) => store.getState().resolutioncenter.atoIncidentHeader.remediationActions[e]
            )
            .map((e) => Number(e))
      )
      .mergeMap(() => Observable.of(changeIncidentStateSuccess(action.payload.newState)))
      .catch((error) => Observable.of(epicsErrorHandler(changeIncidentStateError, error)))
      .takeUntil(action$.ofType(CHANGE_INCIDENT_STATE_REQUEST_ASYNC.CANCEL))
  )

const changeAssigneeEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(CHANGE_ASSIGNEES_ASYNC.INITIATE).switchMap((action) =>
    api.resolutionCenter
      .changeAtoAssignee(action.payload.incidentId, {
        assignee_id: action.payload.assigneeId,
      })
      .map((response) => changeAtoAssigneesSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(changeAtoAssigneesError, error)))
      .takeUntil(action$.ofType(CHANGE_ASSIGNEES_ASYNC.CANCEL))
  )

export default combineEpics(changeIncidentStateEpic, changeAssigneeEpic)
